import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { useCallback } from 'react'
import { createExcelBlob } from '@/utils/fileHelper'
import { saveAs } from 'file-saver'
import { NonFormUpload } from '@/components/Elements'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import useAL from '../../useAL'

const ALListHeader = ({ title, handleAdd, query }) => {
  //Hooks
  const dispatch = useDispatch()
  const { useFetchAllALs, useUploadALs } = useAL()

  const { data: allALsResponse } = useFetchAllALs({
    ...query,
    page: 1,
    pageSize: 0,
  })

  const uploadALs = useUploadALs()

  const handleUpload = async (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }

    try {
      dispatch(showLoadingOverlay())
      await uploadALs.mutateAsync(file)
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleDownloadAll = useCallback(() => {
    if (!allALsResponse?.data) {
      return
    }
    try {
      let excelData = []
      if (allALsResponse.data.length === 0) {
        excelData = [
          {
            country: '',
            code: '',
            description: '',
            status: '',
          },
        ]
      } else {
        excelData = allALsResponse.data.map((row) => {
          return {
            country: row.country,
            code: row.code,
            description: row.description,
            status: row.isDeleted ? 'inactive' : 'active',
          }
        })
      }

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, `${title}.xlsx`)
    } catch (err) {
      console.log(err)
    }
  }, [allALsResponse?.data, title])

  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>{title}</Heading>
        <HStack mx="5">
          <Button colorScheme="gray" onClick={handleDownloadAll}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>
        <Spacer />
        <Button colorScheme="blue" onClick={handleAdd}>
          Add {title}
        </Button>
      </Flex>
    </>
  )
}

export default ALListHeader
